__turbopack_context__.v({
  "active": "SpotListTabs-module__UeTt0q__active",
  "container": "SpotListTabs-module__UeTt0q__container",
  "tab": "SpotListTabs-module__UeTt0q__tab",
});
